export enum EditorQueryParameters {
  OPEN_QUESTION_EDITOR = 'mbQIdEdit',
  OPEN_NEW_QUESTION_TYPE = 'mbQType',
  CREATE_NEW_QUESTION = 'mbQCreate',
};
